import React from 'react';
import { ReactComponent as OrderIcon } from '../../assets/images/icons/chartOrder.svg';

export default function ChartOrder({ className }) {
  return (
    <OrderIcon className={`icon ${className}`} />
  );
}
